module.exports = __webpack_public_path__ + "static/img/lhyw.1b95257.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lhyw.png
// module id = Ll8I
// module chunks = 0